import { apiRequestWrapper } from '~/helpers/apiRequestWrapper'
import type { Issue } from '~/types/Issue'
import type { DeepPartial } from '~/types/helpers/DeepPartial'

export async function editIssue(id: number, editedIssue: DeepPartial<Issue['attributes']>) {
  const token = useStrapiToken()

  return apiRequestWrapper(`/issuers/issues/${id}`, {}, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token.value}`,
    },
    body: {
      ...editedIssue,
    },
  })
}
